import { Pipe, PipeTransform } from '@angular/core';
import { MembershipPaymentMode } from '@features/packages/enum/membershipPaymentMode.enum';


@Pipe({
  name: 'paymentModeLabel'
})
export class PaymentModeLabelPipe implements PipeTransform {
  transform(value: MembershipPaymentMode): string {
    switch (value) {
      case MembershipPaymentMode.Cash:
        return 'Cash';
      case MembershipPaymentMode.BankTransfer:
        return 'Debit/Credit Card';
      case MembershipPaymentMode.UPI:
        return 'UPI';
      default:
        return '-';
    }
  }
}
